import { render, staticRenderFns } from "./AccountsPayableResourceList.vue?vue&type=template&id=23f1ff00&"
import script from "./AccountsPayableResourceList.vue?vue&type=script&lang=js&"
export * from "./AccountsPayableResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports